import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import { useRef, useState } from "react";
import SliderCard from "./slider-card";
import style from "../slider.module.scss";
import { ReactComponent as ArrowCircle } from "../../assets/icons/arrow-circle.svg";
import "swiper/css";
import "swiper/css/free-mode";
import clsx from "clsx";

const SliderAllVideos = ({ videos, setSelectedIndex }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [totalSlides, setTotalSlides] = useState(0);
  const swiperRef = useRef(null);
  return (
    <div className={style.slider}>
      <div>
        <Swiper
          slidesPerView={1.5}
          spaceBetween={30}
          freeMode={true}
          modules={[FreeMode]}
          className={style.swiper}
          onSlideChange={(s) => {
            setCurrentSlide(s.realIndex);
            setTotalSlides(s.snapGrid.length);
          }}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
            setTotalSlides(swiper.snapGrid.length);
          }}
          breakpoints={{
            767: {
              slidesPerView: 3.5,
            },
          }}
        >
          {videos.map((video, i) => (
            <SwiperSlide key={i} onClick={() => setSelectedIndex(i)}>
              <SliderCard video={video} swiperRef={swiperRef} slideIndex={i} />
            </SwiperSlide>
          ))}
        </Swiper>
        <div
          className={clsx(style.controlsContainer)}
          style={{
            "--controls-primary": "#ffffff",
          }}
        >
          <div className={style.controls}>
            <button
              className={clsx(currentSlide === 0 && style.gray)}
              onClick={() => {
                if (swiperRef.current) {
                  swiperRef.current.slidePrev(); // Passer à la slide précédente
                }
              }}
            >
              <ArrowCircle />
            </button>
            <span>
              {currentSlide + 1} sur {totalSlides}
            </span>
            <button
              className={clsx(currentSlide + 1 === totalSlides && style.gray)}
              onClick={() => {
                if (swiperRef.current) {
                  swiperRef.current.slideNext(); // Passer à la slide suivante
                }
              }}
            >
              <ArrowCircle />
            </button>
          </div>
          <div className={style.progressBar}>
            <div className={style.bar}></div>
            <div
              className={style.progress}
              style={{
                width: ((currentSlide + 1) / totalSlides) * 100 + "%",
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SliderAllVideos;
